import { TaskStatus } from '../enums/TaskStatus';
import { NotificationSeverity } from '@/components/notifications/Notification';
import { useNotification } from '@/hooks';
import { TaskSchema } from '../schemas';
import { mapTaskFormToCreateTaskDto } from '../adapters';
import {
  useUpdateTaskMutation,
  useDeleteTaskMutation,
  useCreateTaskMutation,
} from '../services/tasks.service';

const useTaskActions = () => {
  const [updateTask, { isLoading: isUpdateTaskLoading }] =
    useUpdateTaskMutation();
  const [deleteTask, { isLoading: isDeleteTaskLoading }] =
    useDeleteTaskMutation();
  const [createTask, { isLoading: isCreateTaskLoading }] =
    useCreateTaskMutation();

  const { showNotification } = useNotification();

  const onUpdateTask = async (id: string, status: string) => {
    const newStatus =
      status === TaskStatus.ACTIVE ? TaskStatus.INACTIVE : TaskStatus.ACTIVE;
    try {
      await updateTask({
        id,
        data: {
          status: newStatus,
        },
      }).unwrap();
      showNotification(
        `Tarea ${newStatus === TaskStatus.INACTIVE ? 'in' : ''}activada correctamente.`,
        NotificationSeverity.success
      );
    } catch (error) {
      showNotification(
        'Ocurrió un error al cambiar el estado de una tarea. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
    }
  };

  const onDeleteTask = async (id: string) => {
    try {
      await deleteTask(id).unwrap();
      showNotification(
        'Tarea eliminada correctamente',
        NotificationSeverity.success
      );
    } catch (error) {
      showNotification(
        'Ocurrió un error al eliminar una tarea. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
    }
  };

  const onCreateTask = async (data: TaskSchema, reset: () => void) => {
    try {
      await createTask(mapTaskFormToCreateTaskDto(data)).unwrap();
      showNotification(
        'Tarea creada correctamente',
        NotificationSeverity.success
      );
      reset();
    } catch (error) {
      showNotification(
        'Ocurrió un error al crear una tarea. Inténtalo nuevamente.',
        NotificationSeverity.error
      );
    }
  };

  return {
    onUpdateTask,
    isUpdateTaskLoading,
    onDeleteTask,
    isDeleteTaskLoading,
    onCreateTask,
    isCreateTaskLoading,
  };
};

export default useTaskActions;
